import script from "./topHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./topHeader.vue?vue&type=script&setup=true&lang=js"

import "./topHeader.vue?vue&type=style&index=0&id=50222650&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50222650"]])

export default __exports__